#import "../fragments/shared-inbox-address-fragment.graphql"

query GetSharedInboxConfig {
    sharedInboxConfig {
        ...SharedInboxAddressFragment
    }
}
